const init = () => {
    const header = document.querySelector('.header');
    const nav = document.querySelector('.navigation');
    const form = document.querySelector('form');
    const hamburger = document.querySelector('#hamburger');
    const body = document.querySelector('body');
    const dropdowns = document.querySelectorAll('.hasDropdown');

    hamburger.addEventListener('click', () => {
        header.classList.toggle('active');
        hamburger.classList.toggle('open');
        body.classList.toggle('noOverflow');
        setAria();
    })

    // Create loop around focusable elements for SR
    hamburger.addEventListener('keydown', (e) => {
        if (event.keyCode == 9) {
            e.preventDefault();
            if (header.classList.contains('active')) {
                nav.querySelector('li:first-of-type a').focus();
            } else {
                form.querySelector('select').focus();
            }
        }
    });

    const setAria = () => {
        const menuAria = hamburger.getAttribute('aria-label');
        if (menuAria === 'Open navigation menu') {
            hamburger.setAttribute('aria-label', 'Close navigation menu')
            return
        }
        hamburger.setAttribute('aria-label', 'Open navigation menu')
    }

    dropdowns.forEach(dropdown => {
        const anchor = dropdown.querySelector('a');
        anchor.addEventListener('click', (e) => {
            e.preventDefault();
            dropdown.classList.toggle('mobileActive');
        })
    })
}

function ready(init) {
    if (document.readyState != 'loading') {
        init();
    } else {
        document.addEventListener('DOMContentLoaded', init);
    }
}

ready(init);